/**
 * Supported locales (TMMRSL-0005). Ported from tmm-app TMMAPP-0001. Kept in step
 * with saas-auth's supported set (en/es/fr/pt). The product launches in one
 * language; every user-visible string still goes through i18next.
 */
export const SUPPORTED_LOCALES = ['en', 'es', 'fr', 'pt'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'en';
export const LOCALE_STORAGE_KEY = 'tmm_reseller_admin.locale';

export function isSupportedLocale(value: unknown): value is SupportedLocale {
  return typeof value === 'string' && (SUPPORTED_LOCALES as readonly string[]).includes(value);
}

/** `es-MX` → `es`; unsupported or empty → null. */
export function normalizeLocale(input: string | null | undefined): SupportedLocale | null {
  if (!input) return null;
  const primary = input.toLowerCase().split(/[-_]/)[0];
  if (!primary) return null;
  return isSupportedLocale(primary) ? primary : null;
}

/** Portuguese presentation targets Brazil; persisted and picker values stay `pt`. */
export function intlLocale(locale: string): string {
  return locale === 'pt' ? 'pt-BR' : locale;
}
